import React from 'react';
import { Volume2, VolumeX } from 'lucide-react';
interface SoundToggleProps {
  enabled: boolean;
  onToggle: () => void;
}
export function SoundToggle({
  enabled,
  onToggle
}: SoundToggleProps) {
  return <button type="button" onClick={onToggle} aria-pressed={enabled} aria-label={enabled ? 'Turn report sounds off' : 'Turn report sounds on'} title={enabled ? 'Sound on' : 'Sound off'} className="inline-flex min-h-[40px] items-center gap-2 rounded-lg px-3 text-xs font-medium text-forensic-subtle transition-colors duration-150 ease-out hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-forensic-crimson-soft" data-id="element-429" data-mp="2ovqp45d0kz4q">
      {enabled ? <Volume2 size={16} aria-hidden="true" data-id="element-430" data-mp="2awh5evplnmw0" /> : <VolumeX size={16} aria-hidden="true" data-id="element-431" data-mp="2ay25f0uony19" />}
      <span className="hidden whitespace-nowrap sm:inline" data-id="element-432" data-mp="1dg1zf68dlm08">{enabled ? 'Sound on' : 'Sound off'}</span>
    </button>;
}